import {
    POST,
    postFile,
    GET
} from "../../index";
export const selectAllTerminal = (param) => POST("/v1/terminal/selectAllTerminal", param);
export const insertTerminal = (param) => POST("/v1/terminal/insertTerminal", param);
export const updateTerminal = (param) => POST("/v1/terminal/updateTerminal", param);
export const deleteTerminal = (param) => POST("/v1/terminal/deleteTerminal", param);
export const batchTransferTerminal = (param) => POST("/v1/terminal/batchTransferTerminal", param);
export const syncTerminalOrg = (param) => POST("/v1/terminal/syncTerminalOrg", param);
export const uploadTerminalModel = (param) => postFile("/v1/getExportExcel/uploadTerminalModel", param);
export const refreshTerminal = (param) => POST("/v1/terminal/refreshTerminal", param);
export const abandonedTerminal = (param) => POST("/v1/terminal/abandonedTerminal", param);

export const downLoadTemplateFile = () => GET('/v1/getExportExcel/exportTerminalModel')
export const exportTerminalFile = (params) => GET(`/v1/getExportExcel/exportTerminal`,params)